// extracted by mini-css-extract-plugin
module.exports = {"tab":"_772e1b1e50--tab--ltzfz","active":"_772e1b1e50--active--el6Hw","text":"_772e1b1e50--text--EmF40"};